import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import NoPrizeImage from '../../../../assets/no-prize-icon.svg?url';
import { CustomCSSProperties } from '../../../../types';

import styles from './index.module.css';

export const NoPrize = ({ height }: { height: number }) => {
  const { t } = useI18n();

  return (
    <Box
      direction="column"
      justify="center"
      align="center"
      className={styles.container}
      style={
        {
          '--height': `${height}px`
        } as CustomCSSProperties
      }
    >
      <Box className={styles.imageWrapper}>
        <img src={NoPrizeImage} alt="opened box" className={styles.image} />
      </Box>
      <AText component="strong" className={styles.title}>
        {t('web.wheel.empty.content1')}
      </AText>
      <AText component="p" className={styles.description}>
        {t('web.wheel.empty.content2')}
      </AText>
      <AText component="p" className={styles.description}>
        {t('web.wheel.empty.content3')}
      </AText>
    </Box>
  );
};
